<template>
  <b-modal
    ref="modal"
    v-model="isShown"
    :title="$t('views.consolidator_asn_shipment.select_asn')"
    modal-class="spso-modal"
    hide-header-close
    hide-footer
    centered
    size="lg"
    @shown="clear"
    @hidden="hideModal"
  >
    <v-form
      ref="form"
      class="mt-3"
      @submit.prevent="submit"
    >
      <div class="input-block input-block_white">
        <label class="input-block__label">
          {{ $t('views.consolidator_asn_shipment.serial_number') }}
        </label>
        <v-text-field
          v-model="serialNumber"
          solo
          readonly
        />
      </div>
      <div class="input-block input-block_white">
        <label class="input-block__label">
          {{ $t('common.asn') }}
        </label>
        <v-select
          v-model="asn"
          :items="asnList"
          :item-text="asnText"
          solo
          return-object
          hide-no-data
          :rules="[rules.required]"
        />
      </div>
      <div class="v-application d-flex">
        <v-btn
          class="mr-4 flex-grow-1"
          outlined
          large
          @click="hideModal"
        >
          {{ $t('common.cancel') }}
        </v-btn>
        <v-btn
          color="primary"
          class="flex-grow-1"
          outlined
          large
          type="submit"
        >
          {{ $t('common.add') }}
        </v-btn>
      </div>
    </v-form>
  </b-modal>
</template>

<script>
export default {
  name: 'PalletModal',

  model: {
    prop: 'value',
  },

  props: {
    value: {
      type: Boolean,
      default: () => false,
    },

    serialNumber: {
      type: String,
      required: true,
    },

    asnList: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      rules: {
        required: (value) => Boolean(value) || this.$t('validation.required'),
      },
      isShown: false,
      asn: {},
    };
  },

  watch: {
    value(val) {
      this.isShown = val;
    },
  },

  methods: {
    asnText(asn) {
      return `${asn.number} ${this.$t('common.dated')} ${this.$moment(asn.date).format('L')}`;
    },

    clear() {
      this.asn = {};
    },

    hideModal() {
      this.$emit('input', false);
    },

    submit() {
      if (!this.validate()) {
        return;
      }
      this.$emit('selectAsn', this.asn);
    },

    validate() {
      this.$refs.form.validate();
      return Boolean(this.asn.id);
    },
  },
};
</script>
